import { useState, useEffect, useLayoutEffect } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { navigationConfig, findNavigationItemByPathname } from '../../util/navigation'
import globalStyle from '../../styles/common.module.css'
import style from './header.module.css'
import { PagesQuery } from '../../util/types'

export function Header({data}: {data: PagesQuery["pages"] | undefined}) {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => {
    setOpen(false)
    window.scrollTo(0,0)
  }, [pathname])

  // Prevent body scroll when menu is open on mobile
  useLayoutEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    // Cleanup: restore scroll when component unmounts
    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  if(pathname === '/') {
    return null
  }

  const filteredNavigationItems = navigationConfig.filter((item) => {
    if(item.id === "collections") return true
    return data?.find((page) => page.slug === item.id)
})

  return (
    <div className={[style.headerWrapper, open ? style.open : ''].join(' ')}>
      <nav className={[style.header, open ? style.open : ''].join(' ')}>
        <Link to='/' className={style.logo}>
          <img src='assets/icons/logo-ep.svg' alt='edit please logo' />
        </Link>

        <div className={style.links}>
          {filteredNavigationItems.map((item) => {
            return (
              <Link
                to={item.path}
                key={item.id}
                className={[
                  globalStyle.buttonSM,
                  globalStyle.fontGray2,
                  pathname === item.path ? style.active : '',
                ].join(' ')}
              >
                {item.nameInMenu}
              </Link>
            )
          })}
        </div>

        <div className={style.mobileHeader}>
          <p className={globalStyle.subtitle}> Menu </p>
          <img src='assets/icons/close.svg' alt='close menu' onClick={() => setOpen(false)} />
        </div>
      </nav>
      <div className={style.mobileCollapsed} onClick={() => setOpen(true)}>
        <p className={[globalStyle.buttonSM, globalStyle.fontGray2, style.currentPage].join(' ')}>
          {(() => {
            const currentItem = findNavigationItemByPathname(pathname)
            return currentItem ? currentItem.nameInMenu : 'Menu'
          })()}
        </p>
        <img src='assets/icons/menu.svg' alt='close menu' />
      </div>
    </div>
  )
}

